module.exports = __webpack_public_path__ + "static/media/Football-mobile.a5966742.jpg";